module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\n    if ((data.locked || data.bundleLocked) && data.isSearch ) {\n        data.lockIconClass = 'bundle-lock';\n        data.lockGradientClass = 'bundle-lock-gradient';\n        data.isUserSubscriber = CBS.Registry.user_auth && CBS.Registry.user.sub_status !== 'REGISTERED' && CBS.Registry.user.sub_status !== 'EX_SUBSCRIBER'\n    }\n\nlet _href = data.href;\nif (data.isEvent) {\n_href = 'javascript:void(0)';\n}\n\n%>\n\n<a href=\"<%= _href %>\" class=\"ch-expanded-container <%= data.cType %>-expanded-container\" id=\"<%= data.id %>\"     \n    <% if(data.showSeriesTitle && data.cType == 'ch') { %>\n        data-showId=\"<%= data.showId  %>\"\n    <% } %>\n>\n    <div class=\"media-manager-container\"></div>\n\n    <% if (data.cType == 'ch') { %>\n        <% if (data.badgeLabel){ %>\n    <div class=\"new-item-container\">\n        <div class=\"new-item\"><%= data.badgeLabel %></div>\n    </div>\n<% } %>\n    <% } %>    \n\n    <div class=\"<%= data.cType %>-expanded-overlay-components\">\n        <% if(data.carouselType === 'keep-watching' && data.cType == 'ch') { %>\n            <%\nlet _uuid = Math.floor((Math.random() * 1000000) + 1);\nlet progress = data.progress;\n%>\n\n<div class=\"ch-keep-watching-bottom-components\">\n    <% if ((data.seasonNumber && data.episodeNumber && data.genre != 'SPORTS') || data.showEpisodeLabel) { \n        const kwData = {\n            season: data.seasonNumber,\n            episodeNumber: data.episodeNumber\n        }    \n    %>\n        <% if (data.isMovie === false) { %>\n            <div class=\"ch-info-wrapper\">\n                <% if (data.seasonNumber && data.episodeNumber && data.isEpisodeless !== true) { %>\n                    <div class=\"ch-season-episode-info\">\n                        <%= interpolateUrl(getLocale(\"season_episode_abbr\"), kwData) %>:&nbsp;\n                    </div>\n                <% } %>\n                <div class=\"ch-episode-title\">\n                    <%= data.showEpisodeLabel %>\n                </div>\n            </div>\n        <% } %>\n    <% } %>\n\n    <%# Progress Bar %>\n    <% if (progress !== 0 && progress !== 0.0) { %>\n        <div class=\"ch-progress-bar-wrapper<%= data.isMovie === true ? ' ch-progress-bar-wrapper--movie' : '' %>\">\n            <%# %>\n<%# You must set _uuid & progress before including this file %>\n<%# hasRendered should also be set to true during browser resize before this tpl is rendered again, see gridView.js %>\n<%# %>\n<% if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { %>\n<style>\n\n    #progress-bar-<%= _uuid %> {\n        width: auto;\n        height: 4px;\n        border-radius: 500px;\n        background: rgba(255, 255, 255, 0.20);\n    }\n\n    #progress-bar-<%= _uuid %> .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        background-image: linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        height: 4px;\n        border-radius: 500px 0 0 500px;\n        background: #FFFFFF;\n        width: 0;\n\n        -webkit-animation: slideProgress-<%= _uuid %> ease-in 1;\n        /* call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time */\n        -moz-animation: slideProgress-<%= _uuid %> ease-in 1;\n        animation: slideProgress-<%= _uuid %> ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        <%# /* this makes sure that after animation is done we remain at the last keyframe value (opacity: 1)*/ %>\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-<%= _uuid %> .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;}\n\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-<%= _uuid %>\" data-percentage=\"<%= progress %>\">\n    <div class=\"bar<% if (typeof hasRendered !== 'undefined' && hasRendered) { %> hasRendered <% } %>\"></div>\n</div>\n<% } %>\n            <div class=\"ch-time-stamp\">\n                <%= data.timeStamp %>\n            </div>\n        </div>\n    <% } %>\n\n</div>\n\n        <% } else if (data.isLive) { %>\n            <%\nlet _uuid = Math.floor((Math.random() * 1000000) + 1);\nlet progress = data.progress;\n%>\n\n<div class=\"ch-live-bottom-components\">\n    <div class=\"<%= data.cType %>-description\">\n        <%= data.about %>\n    </div>\n\n    <% if (!data.isUpcomingListing) { %>\n        <div class=\"ch-progress-bar-wrapper\">\n            <%# Progress Bar %>\n            <%# %>\n<%# You must set _uuid & progress before including this file %>\n<%# hasRendered should also be set to true during browser resize before this tpl is rendered again, see gridView.js %>\n<%# %>\n<% if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { %>\n<style>\n\n    #progress-bar-<%= _uuid %> {\n        width: auto;\n        height: 4px;\n        border-radius: 500px;\n        background: rgba(255, 255, 255, 0.20);\n    }\n\n    #progress-bar-<%= _uuid %> .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        background-image: linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        height: 4px;\n        border-radius: 500px 0 0 500px;\n        background: #FFFFFF;\n        width: 0;\n\n        -webkit-animation: slideProgress-<%= _uuid %> ease-in 1;\n        /* call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time */\n        -moz-animation: slideProgress-<%= _uuid %> ease-in 1;\n        animation: slideProgress-<%= _uuid %> ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        <%# /* this makes sure that after animation is done we remain at the last keyframe value (opacity: 1)*/ %>\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-<%= _uuid %> .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;}\n\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-<%= _uuid %>\" data-percentage=\"<%= progress %>\">\n    <div class=\"bar<% if (typeof hasRendered !== 'undefined' && hasRendered) { %> hasRendered <% } %>\"></div>\n</div>\n<% } %>\n            <p class=\"ch-progress-text\">\n                <%= data.progressText %>\n            </p>\n        </div>\n    <% } %>\n</div>\n\n<% if (data.cType == 'ch' && data.lockIconClass && data.isUserSubscriber){ %>\n    <div class=\"<%= data.cType %>-bundle-locked\">\n        <div class=\"portrait label bundle-lock\">\n            <img src=\"/assets/images/svg/content_lock.svg\"/>\n        </div>\n        <div class=\"<%= data.cType %>-lock-text\"><span><%= getLocale('get_pplus_showtime')%></span></div>\n    </div>\n<% } %>\n        <% } else if (data.model==='videoConfig') { %>\n            <%\n    let _uuid = Math.floor((Math.random() * 1000000) + 1);\n    let progress = data.progress;\n    let hasProgress = data.progress && data.progress > 0;\n    let chClass = hasProgress ? \"video-conf-kw-bottom-components\" : \"ch-bottom-components\";\n%>\n\n<% if (data.cType == 'ch') { %>\n<div class=\"<%= chClass %>\">\n<% } %>\n    <% if(hasProgress){ %>\n        <div class=\"ch-info-wrapper\">\n            <% if(data.seasonNumber && data.episodeNumber && data.title && !data.showSeasonless && !data.showEpisodeless){ %>\n                <div class=\"ch-season-episode-info\">\n                    <span class=\"meta-white\">\n                        <abbr aria-label=\"Season <%= data.seasonNumber %>\" title=\"<%= getLocale('season') %> <%= data.seasonNumber %>\">\n                            <%= getLocale('season_number_abbr', {'seasonNumber': data.seasonNumber }) %>\n                        </abbr>\n                    </span>\n                    <span class=\"meta-white\">\n                        <abbr aria-label=\"Episode <%= data.episodeNumber %>\" title=\"<%= getLocale('episode') %> <%= data.episodeNumber %>\">\n                            <%= getLocale('episode_number_abbr', {'episodeNum': data.episodeNumber }) %>\n                        </abbr>\n                    </span>\n                    <span class=\"ch-episode-title\"><%= data.title %></span>\n                </div>\n            <% } %>\n        </div>\n\n        <% if(data.ratingIcon && CBS.Registry.region.international) { %>\n            <div class=\"ch-rating-wrapper\">\n                <img src=\"<%= data.ratingIcon %>\" />\n            </div>\n        <% }else if (data.rating){ %>\n            <div class=\"ch-rating-wrapper\">\n                <span><%= data.rating  %></span>\n            </div>\n        <% } %>\n\n        <div class=\"ch-progress-bar-wrapper\">\n            <%# Progress Bar %>\n            <%# %>\n<%# You must set _uuid & progress before including this file %>\n<%# hasRendered should also be set to true during browser resize before this tpl is rendered again, see gridView.js %>\n<%# %>\n<% if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { %>\n<style>\n\n    #progress-bar-<%= _uuid %> {\n        width: auto;\n        height: 4px;\n        border-radius: 500px;\n        background: rgba(255, 255, 255, 0.20);\n    }\n\n    #progress-bar-<%= _uuid %> .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        background-image: linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        height: 4px;\n        border-radius: 500px 0 0 500px;\n        background: #FFFFFF;\n        width: 0;\n\n        -webkit-animation: slideProgress-<%= _uuid %> ease-in 1;\n        /* call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time */\n        -moz-animation: slideProgress-<%= _uuid %> ease-in 1;\n        animation: slideProgress-<%= _uuid %> ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        <%# /* this makes sure that after animation is done we remain at the last keyframe value (opacity: 1)*/ %>\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-<%= _uuid %> .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;}\n\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n    @keyframes slideProgress-<%= _uuid %> {\n        from {\n            width: 0;\n        }\n        to {\n            width: <%= progress %>%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-<%= _uuid %>\" data-percentage=\"<%= progress %>\">\n    <div class=\"bar<% if (typeof hasRendered !== 'undefined' && hasRendered) { %> hasRendered <% } %>\"></div>\n</div>\n<% } %>\n            <div class=\"ch-time-stamp\">\n                <%= data.timeStamp %>\n            </div>\n        </div>\n    <% } else { %>\n\n        <div class=\"<%= data.cType %>-info-wrapper\">\n            <!-- START ch related -->\n            <% if (data.cType == 'ch') { %>\n                <% if(data.ratingIcon && CBS.Registry.region.international) { %>\n                    <span class=\"ch-rating\">\n                        <img src=\"<%= data.ratingIcon %>\" />\n                    </span>\n                <% } %>\n                <% if (data.isMovie && typeof(data?.unifiedGenre?.[0]) !== \"undefined\"){ %>\n                    <span><%= data.unifiedGenre[0] %></span>\n                <% } %>\n                <% if (!data.isMovie && data.chAirDate){ %>\n                    <span><%= data.chAirDate %> </span>\n                <% } else if (data.isMovie && data.chAirDateYear) { %>\n                    <span><%= data.chAirDateYear %> </span>\n                <% } %>\n                <% if(data.rating && !CBS.Registry.region.international) { %>\n                    <span><%= data.rating %></span>\n                <% } %>\n                <% if (data.chDuration){ %>\n                    <span><%= data.chDuration %> </span>\n                <% } %>\n            <% } %>\n            <!-- END ch related -->\n        </div>\n\n        <% if(data.seasonNumber && data.episodeNumber && data.title && !data.showSeasonless && !data.showEpisodeless) { %>\n            <div class=\"ch-season-episode-wrapper\">\n                <span class=\"meta-white\">\n                    <abbr aria-label=\"Season <%= data.seasonNumber %>\" title=\"<%= getLocale('season') %> <%= data.seasonNumber %>\">\n                        <%= getLocale('season_number_abbr', {'seasonNumber': data.seasonNumber }) %>\n                    </abbr>\n                </span>\n                <span class=\"meta-white\">\n                    <abbr aria-label=\"Episode <%= data.episodeNumber %>\" title=\"<%= getLocale('episode') %> <%= data.episodeNumber %>\">\n                        <%= getLocale('episode_number_abbr', {'episodeNum': data.episodeNumber }) %>\n                    </abbr>\n                </span>\n                <span class=\"meta-white meta-white-thin\"><%= data.title %></span>\n            </div>\n        <% } else if(!data.isMovie && data.label) { %>\n            <div class=\"ch-season-episode-wrapper\">\n                <span class=\"meta-white meta-white-semibold\"><%= data.label %></span>\n            </div>\n        <% } %>\n\n        <% if (data.about && data.cType == 'ch'){ %>\n            <div class=\"<%= data.cType %>-description <%= data.lockIconClass %>\">\n                <%= data.about %>\n            </div>\n        <% } %>\n        \n        <% if (data.castNames) { %>\n            <div class=\"highlight-cast-wrapper\">\n    <div class=\"highlight-cast\">\n        <%= getLocale('starring_')%> <%- data.castNames %>\n    </div>\n</div>\n        <% } %>\n        \n        <% if (data.cType == 'ch' && data.lockIconClass && data.isUserSubscriber){ %>\n            <div class=\"<%= data.cType %>-bundle-locked\">\n                <div class=\"portrait label bundle-lock\">\n                    <img src=\"/assets/images/svg/content_lock.svg\"/>\n                </div>\n                <div class=\"<%= data.cType %>-lock-text\"><span><%= getLocale('get_pplus_showtime')%></span></div>\n            </div>\n        <% } %>\n    <% } %>    \n<% if (data.cType == 'ch') { %>    \n</div>\n<% } %>\n        <% } else { %>\n            <% if (data.cType == 'ch') { %>\n<div class=\"<%= data.cType %>-bottom-components\">\n<% } %>    \n    <div class=\"<%= data.cType %>-info-wrapper\">\n        <!-- check to only show rating if one of the needed values is present -->\n        <%\n        let neededValues = { genre: data.genre, premiereDate: data.premiereDate, seasonCounts: data.seasonCounts, movieDuration: data.movieDuration };\n        let oneNeededValueMet = Object.values(neededValues).some(v => v)\n        %>\n        \n        <!-- START prominent related -->\n        <% if (data.cType == 'prominent') { %>\n            <% if ( ((data.locked || data.bundleLocked) && data.isUserSubscriber) || (data.isLocal && data.lockIcon && !data.isUserSubscriber) ) { %>\n            <div class=\"<%= data.lockGradientClass %>\"></div>\n            <div class=\"label <%= data.lockIconClass %>\">\n                <img src=\"<%= data.lockIcon %>\"/>\n            </div>\n            <% } %>\n        <% } %>\n        <!-- END prominent related -->\n        \n        <% if (typeof(data.genre) !== \"undefined\" && data.genre){ %>\n            <span><%= data.genre %></span>\n        <% } %>\n\n        <!-- START prominent related -->\n        <% if (data.cType == 'prominent') { %>\n            <% if (data.year){ %>\n            <span><%= data.year %> </span>\n            <% } %>\n        <% } %>\n        <!-- END prominent related -->\n\n        <!-- START ch related -->\n        <% if (data.cType == 'ch') { %>\n            <% if (data.premiereDate && data.genre != 'SPORTS'){ %>\n                <span><%= data.premiereDate %> </span>\n            <% } %>\n        <% } %>\n        <!-- END ch related -->\n        \n        <% if ((data.seasonCounts && data.isSeasonless !== true && data.cType == 'ch') || (data.seasonCounts && data.cType == 'prominent')){ %>\n            <span><%= data.numSeasons > 1 ? interpolateUrl(getLocale('_seasons'), {seasonCount: data.numSeasons}).toUpperCase() : getLocale('1_season').toUpperCase() %></span>\n        <% } %>\n        \n        <% if(data.ratingIcon && CBS.Registry.region.international && oneNeededValueMet && data.cType == 'ch') { %>\n            <span class=\"<%= data.cType %>-rating\">\n                <img src=\"<%= data.ratingIcon %>\" />\n            </span>\n        <% }else if ((data.rating && oneNeededValueMet && data.cType == 'ch') || (data.rating && !CBS.Registry.region.international && data.cType == 'prominent')){ %>\n            <span class=\"<%= data.cType %>-rating\"><%= data.rating %></span>\n        <% } %>\n\n        <!-- START prominent related -->\n        <% if (data.cType == 'prominent') { %>\n            <% if (data.runtime){ %>\n            <span><%= data.runtime %></span>\n            <% } %>\n        <% } %>\n        <!-- END prominent related -->\n\n        <!-- START prominent related -->\n        <% if (data.cType == 'prominent') { %>\n            <% if(data.ratingIcon && CBS.Registry.region.international && data.isMovie) { %>\n            <span class=\"prominent-rating\">\n                        <img src=\"<%= data.ratingIcon %>\" />\n                    </span>\n            <% } %>\n        <% } %>\n        <!-- END prominent related -->\n\n        <!-- START ch related -->\n        <% if (data.cType == 'ch') { %>\n            <% if (data.isMovie && data.movieDuration && data.category != 'SPORTS'){ %>\n            <span><%= data.movieDuration %></span>\n            <% } %>\n        <% } %>\n        <!-- END ch related -->\n    </div>\n\n    <!-- START prominent related -->\n    <% if (data.cType == 'prominent') { %>\n        <% if (data.tuneInTime) { %>\n        <div class=\"prominent-tune-in-time-container\">\n            <p class=\"tuneInTime\"> <%= data.tuneInTime %> </p>\n        </div>\n        <% } %>\n    <% } %>\n    <!-- END prominent related -->\n    \n    <% if (data.about && data.cType == 'ch'){ %>\n        <div class=\"<%= data.cType %>-description <%= data.lockIconClass %>\">\n            <%= data.about %>\n        </div>\n    <% } else if (data.about && data.cType == 'prominent') { %>\n        <div class=\"<%= data.cType %>-description\">\n            <p><%= data.about %></p>\n        </div>\n    <% } %>\n    \n    <% if (data.castNames) { %>\n        <div class=\"highlight-cast-wrapper\">\n    <div class=\"highlight-cast\">\n        <%= getLocale('starring_')%> <%- data.castNames %>\n    </div>\n</div>\n    <% } %>\n    \n    <% if (data.cType == 'ch' && data.lockIconClass && data.isUserSubscriber){ %>\n        <div class=\"<%= data.cType %>-bundle-locked\">\n            <div class=\"portrait label bundle-lock\">\n                <img src=\"/assets/images/svg/content_lock.svg\"/>\n            </div>\n            <div class=\"<%= data.cType %>-lock-text\"><span><%= getLocale('get_pplus_showtime')%></span></div>\n        </div>\n    <% } %>\n<% if (data.cType == 'ch') { %>    \n</div>\n<% } %>\n        <% } %>\n        <%\ndata.watchlist_active_class = data.contentMyListActive ? 'in_watchlist' : ''\ndata.notify_active_class = data.contentNotificationActive ? 'notify_on' : ''\ndata.play_icon_class = data.button.play ? 'playIcon' : ''\n\ndata.profileType = CBS.Registry.user.profile_type ? CBS.Registry.user.profile_type : '';\nlet isSearch = CBS.Registry.pageType === \"Search\"; \n%>\n\n<div class=\"highlight-cta-wrapper\">\n    <div class=\"button-container <%= data.carouselType === 'keep-watching' ? 'keep-watching' : '' %>\">\n        <button class=\"button <%=data.play_icon_class%> highlight-play-button <%= (navigator.userAgent.indexOf('Win') != -1 && data.play_icon_class !== '') ? 'buttonWindows' : '' %>\"\n                aria-label=\"<%=data.button.label%>\"\n                button-url=\"<%=data.button.url%>\">\n            <div class=\"button__text\">\n                <span><%=data.button.label%></span>\n            </div>\n        </button>\n        <% if(data.allowMyListControls && !data.scheduleBadge ) { %>\n           \n            <div class=\"button-with-tooltip highlight-watch-list <%=data.watchlist_active_class%> <%=data.contentMyListActive ? 'active' : ''%>\">\n                <button class=\"highlight-watchlist-cta\"\n                    id=\"watchlist-cta-<%=data.id || data.contentId%>\" \n                    aria-label=\"My List Toggle\"\n                    href-add=\"<%=data.contentMyListAddActionUrl%>\"\n                    href-remove=\"<%=data.contentMyListRemoveActionUrl%>\">\n                    <span class=\"watchlist_copy\">&nbsp;</span>\n                </button>\n                <div class=\"<%= (navigator.userAgent.indexOf('Win') != -1) ? 'ch-tooltip-windows' : '' %> highlight-tooltip\">\n                    <span class=\"tooltip-text tooltip-add-text\"><%= getLocale('add_to_my_list') %></span>\n                    <span class=\"tooltip-text tooltip-remove-text\"><%= getLocale('remove_from_my_list') %></span>\n                </div>\n            </div>\n            \n            <% if (!CBS.Registry.region.international && data.profileType === 'ADULT') { %>\n                <div class=\"button-with-tooltip highlight-notify <%=data.notify_active_class%> <%=data.contentNotificationActive ? 'active' : ''%>\">\n                    <button class=\"highlight-notify-bell-cta\"\n                        id=\"notify-cta-<%=data.id || data.contentId%>\"\n                        aria-label=\"Notifications Toggle\"\n                        href-add=\"<%=data.contentNotificationAddActionUrl%>\"\n                        href-remove=\"<%=data.contentNotificationRemoveActionUrl%>\"\">\n                        <span class=\"notify_copy\">&nbsp;</span>\n                    </button>\n                    <div class=\"<%= (navigator.userAgent.indexOf('Win') != -1) ? 'ch-tooltip-windows' : '' %> highlight-tooltip highlight-tooltip-notify\">\n                        <span class=\"tooltip-text tooltip-add-text\"><%= getLocale('notify_me') %></span>\n                        <span class=\"tooltip-text tooltip-remove-text\"><%= getLocale('turn_off_notifications') %></span>\n                    </div>\n                </div>\n            <% } %>\n        <% } %>\n    </div>\n</div>\n    </div>\n</a>\n"
  , __filename = "node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@301dafbfd58a29a8a3f92aaf155c0754515287fb_fetch-_62wmhmako2s37xw6vgzewjn2le/node_modules/cbs-core-ui/src/js/templates/carousels/highlightCarousel/expandingContainer.tpl";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
data = __locals.data,
  selected = __locals.selected;
  with (locals || {}) {
    ; 
    if ((data.locked || data.bundleLocked) && data.isSearch ) {
        data.lockIconClass = 'bundle-lock';
        data.lockGradientClass = 'bundle-lock-gradient';
        data.isUserSubscriber = CBS.Registry.user_auth && CBS.Registry.user.sub_status !== 'REGISTERED' && CBS.Registry.user.sub_status !== 'EX_SUBSCRIBER'
    }

let _href = data.href;
if (data.isEvent) {
_href = 'javascript:void(0)';
}


    ; __line = 13
    ; __append("\n\n<a href=\"")
    ; __line = 15
    ; __append(escapeFn( _href ))
    ; __append("\" class=\"ch-expanded-container ")
    ; __append(escapeFn( data.cType ))
    ; __append("-expanded-container\" id=\"")
    ; __append(escapeFn( data.id ))
    ; __append("\"     \n    ")
    ; __line = 16
    ;  if(data.showSeriesTitle && data.cType == 'ch') { 
    ; __append("\n        data-showId=\"")
    ; __line = 17
    ; __append(escapeFn( data.showId  ))
    ; __append("\"\n    ")
    ; __line = 18
    ;  } 
    ; __append("\n>\n    <div class=\"media-manager-container\"></div>\n\n    ")
    ; __line = 22
    ;  if (data.cType == 'ch') { 
    ; __append("\n        ")
    ; __line = 23
    ;  if (data.badgeLabel){ 
    ; __append("\n    <div class=\"new-item-container\">\n        <div class=\"new-item\">")
    ; __line = 25
    ; __append(escapeFn( data.badgeLabel ))
    ; __append("</div>\n    </div>\n")
    ; __line = 27
    ;  } 
    ; __append("\n    ")
    ; __line = 28
    ;  } 
    ; __append("    \n\n    <div class=\"")
    ; __line = 30
    ; __append(escapeFn( data.cType ))
    ; __append("-expanded-overlay-components\">\n        ")
    ; __line = 31
    ;  if(data.carouselType === 'keep-watching' && data.cType == 'ch') { 
    ; __append("\n            ")
    ; __line = 32
    ; 
let _uuid = Math.floor((Math.random() * 1000000) + 1);
let progress = data.progress;

    ; __line = 35
    ; __append("\n\n<div class=\"ch-keep-watching-bottom-components\">\n    ")
    ; __line = 38
    ;  if ((data.seasonNumber && data.episodeNumber && data.genre != 'SPORTS') || data.showEpisodeLabel) { 
        const kwData = {
            season: data.seasonNumber,
            episodeNumber: data.episodeNumber
        }    
    
    ; __line = 43
    ; __append("\n        ")
    ; __line = 44
    ;  if (data.isMovie === false) { 
    ; __append("\n            <div class=\"ch-info-wrapper\">\n                ")
    ; __line = 46
    ;  if (data.seasonNumber && data.episodeNumber && data.isEpisodeless !== true) { 
    ; __append("\n                    <div class=\"ch-season-episode-info\">\n                        ")
    ; __line = 48
    ; __append(escapeFn( interpolateUrl(getLocale("season_episode_abbr"), kwData) ))
    ; __append(":&nbsp;\n                    </div>\n                ")
    ; __line = 50
    ;  } 
    ; __append("\n                <div class=\"ch-episode-title\">\n                    ")
    ; __line = 52
    ; __append(escapeFn( data.showEpisodeLabel ))
    ; __append("\n                </div>\n            </div>\n        ")
    ; __line = 55
    ;  } 
    ; __append("\n    ")
    ; __line = 56
    ;  } 
    ; __append("\n\n    ")
    ; __line = 58
    ; __append("\n    ")
    ; __line = 59
    ;  if (progress !== 0 && progress !== 0.0) { 
    ; __append("\n        <div class=\"ch-progress-bar-wrapper")
    ; __line = 60
    ; __append(escapeFn( data.isMovie === true ? ' ch-progress-bar-wrapper--movie' : '' ))
    ; __append("\">\n            ")
    ; __line = 61
    ; __append("\n")
    ; __line = 62
    ; __append("\n")
    ; __line = 63
    ; __append("\n")
    ; __line = 64
    ; __append("\n")
    ; __line = 65
    ;  if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { 
    ; __append("\n<style>\n\n    #progress-bar-")
    ; __line = 68
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        width: auto;\n        height: 4px;\n        border-radius: 500px;\n        background: rgba(255, 255, 255, 0.20);\n    }\n\n    #progress-bar-")
    ; __line = 75
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        background-image: linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        height: 4px;\n        border-radius: 500px 0 0 500px;\n        background: #FFFFFF;\n        width: 0;\n\n        -webkit-animation: slideProgress-")
    ; __line = 84
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        /* call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time */\n        -moz-animation: slideProgress-")
    ; __line = 86
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        animation: slideProgress-")
    ; __line = 87
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        ")
    ; __line = 90
    ; __append("\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-")
    ; __line = 98
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-")
    ; __line = 104
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;}\n\n        to {\n            width: ")
    ; __line = 109
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-")
    ; __line = 113
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 118
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @keyframes slideProgress-")
    ; __line = 122
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 127
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-")
    ; __line = 133
    ; __append(escapeFn( _uuid ))
    ; __append("\" data-percentage=\"")
    ; __append(escapeFn( progress ))
    ; __append("\">\n    <div class=\"bar")
    ; __line = 134
    ;  if (typeof hasRendered !== 'undefined' && hasRendered) { 
    ; __append(" hasRendered ")
    ;  } 
    ; __append("\"></div>\n</div>\n")
    ; __line = 136
    ;  } 
    ; __append("\n            <div class=\"ch-time-stamp\">\n                ")
    ; __line = 138
    ; __append(escapeFn( data.timeStamp ))
    ; __append("\n            </div>\n        </div>\n    ")
    ; __line = 141
    ;  } 
    ; __append("\n\n</div>\n\n        ")
    ; __line = 145
    ;  } else if (data.isLive) { 
    ; __append("\n            ")
    ; __line = 146
    ; 
let _uuid = Math.floor((Math.random() * 1000000) + 1);
let progress = data.progress;

    ; __line = 149
    ; __append("\n\n<div class=\"ch-live-bottom-components\">\n    <div class=\"")
    ; __line = 152
    ; __append(escapeFn( data.cType ))
    ; __append("-description\">\n        ")
    ; __line = 153
    ; __append(escapeFn( data.about ))
    ; __append("\n    </div>\n\n    ")
    ; __line = 156
    ;  if (!data.isUpcomingListing) { 
    ; __append("\n        <div class=\"ch-progress-bar-wrapper\">\n            ")
    ; __line = 158
    ; __append("\n            ")
    ; __line = 159
    ; __append("\n")
    ; __line = 160
    ; __append("\n")
    ; __line = 161
    ; __append("\n")
    ; __line = 162
    ; __append("\n")
    ; __line = 163
    ;  if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { 
    ; __append("\n<style>\n\n    #progress-bar-")
    ; __line = 166
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        width: auto;\n        height: 4px;\n        border-radius: 500px;\n        background: rgba(255, 255, 255, 0.20);\n    }\n\n    #progress-bar-")
    ; __line = 173
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        background-image: linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        height: 4px;\n        border-radius: 500px 0 0 500px;\n        background: #FFFFFF;\n        width: 0;\n\n        -webkit-animation: slideProgress-")
    ; __line = 182
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        /* call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time */\n        -moz-animation: slideProgress-")
    ; __line = 184
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        animation: slideProgress-")
    ; __line = 185
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        ")
    ; __line = 188
    ; __append("\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-")
    ; __line = 196
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-")
    ; __line = 202
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;}\n\n        to {\n            width: ")
    ; __line = 207
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-")
    ; __line = 211
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 216
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @keyframes slideProgress-")
    ; __line = 220
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 225
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-")
    ; __line = 231
    ; __append(escapeFn( _uuid ))
    ; __append("\" data-percentage=\"")
    ; __append(escapeFn( progress ))
    ; __append("\">\n    <div class=\"bar")
    ; __line = 232
    ;  if (typeof hasRendered !== 'undefined' && hasRendered) { 
    ; __append(" hasRendered ")
    ;  } 
    ; __append("\"></div>\n</div>\n")
    ; __line = 234
    ;  } 
    ; __append("\n            <p class=\"ch-progress-text\">\n                ")
    ; __line = 236
    ; __append(escapeFn( data.progressText ))
    ; __append("\n            </p>\n        </div>\n    ")
    ; __line = 239
    ;  } 
    ; __append("\n</div>\n\n")
    ; __line = 242
    ;  if (data.cType == 'ch' && data.lockIconClass && data.isUserSubscriber){ 
    ; __append("\n    <div class=\"")
    ; __line = 243
    ; __append(escapeFn( data.cType ))
    ; __append("-bundle-locked\">\n        <div class=\"portrait label bundle-lock\">\n            <img src=\"/assets/images/svg/content_lock.svg\"/>\n        </div>\n        <div class=\"")
    ; __line = 247
    ; __append(escapeFn( data.cType ))
    ; __append("-lock-text\"><span>")
    ; __append(escapeFn( getLocale('get_pplus_showtime')))
    ; __append("</span></div>\n    </div>\n")
    ; __line = 249
    ;  } 
    ; __append("\n        ")
    ; __line = 250
    ;  } else if (data.model==='videoConfig') { 
    ; __append("\n            ")
    ; __line = 251
    ; 
    let _uuid = Math.floor((Math.random() * 1000000) + 1);
    let progress = data.progress;
    let hasProgress = data.progress && data.progress > 0;
    let chClass = hasProgress ? "video-conf-kw-bottom-components" : "ch-bottom-components";

    ; __line = 256
    ; __append("\n\n")
    ; __line = 258
    ;  if (data.cType == 'ch') { 
    ; __append("\n<div class=\"")
    ; __line = 259
    ; __append(escapeFn( chClass ))
    ; __append("\">\n")
    ; __line = 260
    ;  } 
    ; __append("\n    ")
    ; __line = 261
    ;  if(hasProgress){ 
    ; __append("\n        <div class=\"ch-info-wrapper\">\n            ")
    ; __line = 263
    ;  if(data.seasonNumber && data.episodeNumber && data.title && !data.showSeasonless && !data.showEpisodeless){ 
    ; __append("\n                <div class=\"ch-season-episode-info\">\n                    <span class=\"meta-white\">\n                        <abbr aria-label=\"Season ")
    ; __line = 266
    ; __append(escapeFn( data.seasonNumber ))
    ; __append("\" title=\"")
    ; __append(escapeFn( getLocale('season') ))
    ; __append(" ")
    ; __append(escapeFn( data.seasonNumber ))
    ; __append("\">\n                            ")
    ; __line = 267
    ; __append(escapeFn( getLocale('season_number_abbr', {'seasonNumber': data.seasonNumber }) ))
    ; __append("\n                        </abbr>\n                    </span>\n                    <span class=\"meta-white\">\n                        <abbr aria-label=\"Episode ")
    ; __line = 271
    ; __append(escapeFn( data.episodeNumber ))
    ; __append("\" title=\"")
    ; __append(escapeFn( getLocale('episode') ))
    ; __append(" ")
    ; __append(escapeFn( data.episodeNumber ))
    ; __append("\">\n                            ")
    ; __line = 272
    ; __append(escapeFn( getLocale('episode_number_abbr', {'episodeNum': data.episodeNumber }) ))
    ; __append("\n                        </abbr>\n                    </span>\n                    <span class=\"ch-episode-title\">")
    ; __line = 275
    ; __append(escapeFn( data.title ))
    ; __append("</span>\n                </div>\n            ")
    ; __line = 277
    ;  } 
    ; __append("\n        </div>\n\n        ")
    ; __line = 280
    ;  if(data.ratingIcon && CBS.Registry.region.international) { 
    ; __append("\n            <div class=\"ch-rating-wrapper\">\n                <img src=\"")
    ; __line = 282
    ; __append(escapeFn( data.ratingIcon ))
    ; __append("\" />\n            </div>\n        ")
    ; __line = 284
    ;  }else if (data.rating){ 
    ; __append("\n            <div class=\"ch-rating-wrapper\">\n                <span>")
    ; __line = 286
    ; __append(escapeFn( data.rating  ))
    ; __append("</span>\n            </div>\n        ")
    ; __line = 288
    ;  } 
    ; __append("\n\n        <div class=\"ch-progress-bar-wrapper\">\n            ")
    ; __line = 291
    ; __append("\n            ")
    ; __line = 292
    ; __append("\n")
    ; __line = 293
    ; __append("\n")
    ; __line = 294
    ; __append("\n")
    ; __line = 295
    ; __append("\n")
    ; __line = 296
    ;  if (typeof _uuid !== 'undefined' && typeof progress !== 'undefined') { 
    ; __append("\n<style>\n\n    #progress-bar-")
    ; __line = 299
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        width: auto;\n        height: 4px;\n        border-radius: 500px;\n        background: rgba(255, 255, 255, 0.20);\n    }\n\n    #progress-bar-")
    ; __line = 306
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar {\n        background-color: transparent;\n        background-image: -webkit-linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        background-image: linear-gradient(135deg, #FFFFFF, #FFFFFF);\n        height: 4px;\n        border-radius: 500px 0 0 500px;\n        background: #FFFFFF;\n        width: 0;\n\n        -webkit-animation: slideProgress-")
    ; __line = 315
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        /* call our keyframe named fadeIn, use animattion ease-in and repeat it only 1 time */\n        -moz-animation: slideProgress-")
    ; __line = 317
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1;\n        animation: slideProgress-")
    ; __line = 318
    ; __append(escapeFn( _uuid ))
    ; __append(" ease-in 1s;\n        -webkit-animation-fill-mode: forwards;\n\n        ")
    ; __line = 321
    ; __append("\n        -moz-animation-fill-mode: forwards;\n        animation-fill-mode: forwards;\n        -webkit-animation-duration: 2s;\n        -moz-animation-duration: 2s;\n        animation-duration: 2s;\n    }\n\n    #progress-bar-")
    ; __line = 329
    ; __append(escapeFn( _uuid ))
    ; __append(" .bar.hasRendered {\n        -webkit-animation-duration: 0s;\n        -moz-animation-duration: 0s;\n        animation-duration: 0s;\n    }\n\n    @-webkit-keyframes slideProgress-")
    ; __line = 335
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;}\n\n        to {\n            width: ")
    ; __line = 340
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @-moz-keyframes slideProgress-")
    ; __line = 344
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 349
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n    @keyframes slideProgress-")
    ; __line = 353
    ; __append(escapeFn( _uuid ))
    ; __append(" {\n        from {\n            width: 0;\n        }\n        to {\n            width: ")
    ; __line = 358
    ; __append(escapeFn( progress ))
    ; __append("%;\n        }\n    }\n\n</style>\n\n<div class=\"progress-bar\" id=\"progress-bar-")
    ; __line = 364
    ; __append(escapeFn( _uuid ))
    ; __append("\" data-percentage=\"")
    ; __append(escapeFn( progress ))
    ; __append("\">\n    <div class=\"bar")
    ; __line = 365
    ;  if (typeof hasRendered !== 'undefined' && hasRendered) { 
    ; __append(" hasRendered ")
    ;  } 
    ; __append("\"></div>\n</div>\n")
    ; __line = 367
    ;  } 
    ; __append("\n            <div class=\"ch-time-stamp\">\n                ")
    ; __line = 369
    ; __append(escapeFn( data.timeStamp ))
    ; __append("\n            </div>\n        </div>\n    ")
    ; __line = 372
    ;  } else { 
    ; __append("\n\n        <div class=\"")
    ; __line = 374
    ; __append(escapeFn( data.cType ))
    ; __append("-info-wrapper\">\n            <!-- START ch related -->\n            ")
    ; __line = 376
    ;  if (data.cType == 'ch') { 
    ; __append("\n                ")
    ; __line = 377
    ;  if(data.ratingIcon && CBS.Registry.region.international) { 
    ; __append("\n                    <span class=\"ch-rating\">\n                        <img src=\"")
    ; __line = 379
    ; __append(escapeFn( data.ratingIcon ))
    ; __append("\" />\n                    </span>\n                ")
    ; __line = 381
    ;  } 
    ; __append("\n                ")
    ; __line = 382
    ;  if (data.isMovie && typeof(data?.unifiedGenre?.[0]) !== "undefined"){ 
    ; __append("\n                    <span>")
    ; __line = 383
    ; __append(escapeFn( data.unifiedGenre[0] ))
    ; __append("</span>\n                ")
    ; __line = 384
    ;  } 
    ; __append("\n                ")
    ; __line = 385
    ;  if (!data.isMovie && data.chAirDate){ 
    ; __append("\n                    <span>")
    ; __line = 386
    ; __append(escapeFn( data.chAirDate ))
    ; __append(" </span>\n                ")
    ; __line = 387
    ;  } else if (data.isMovie && data.chAirDateYear) { 
    ; __append("\n                    <span>")
    ; __line = 388
    ; __append(escapeFn( data.chAirDateYear ))
    ; __append(" </span>\n                ")
    ; __line = 389
    ;  } 
    ; __append("\n                ")
    ; __line = 390
    ;  if(data.rating && !CBS.Registry.region.international) { 
    ; __append("\n                    <span>")
    ; __line = 391
    ; __append(escapeFn( data.rating ))
    ; __append("</span>\n                ")
    ; __line = 392
    ;  } 
    ; __append("\n                ")
    ; __line = 393
    ;  if (data.chDuration){ 
    ; __append("\n                    <span>")
    ; __line = 394
    ; __append(escapeFn( data.chDuration ))
    ; __append(" </span>\n                ")
    ; __line = 395
    ;  } 
    ; __append("\n            ")
    ; __line = 396
    ;  } 
    ; __append("\n            <!-- END ch related -->\n        </div>\n\n        ")
    ; __line = 400
    ;  if(data.seasonNumber && data.episodeNumber && data.title && !data.showSeasonless && !data.showEpisodeless) { 
    ; __append("\n            <div class=\"ch-season-episode-wrapper\">\n                <span class=\"meta-white\">\n                    <abbr aria-label=\"Season ")
    ; __line = 403
    ; __append(escapeFn( data.seasonNumber ))
    ; __append("\" title=\"")
    ; __append(escapeFn( getLocale('season') ))
    ; __append(" ")
    ; __append(escapeFn( data.seasonNumber ))
    ; __append("\">\n                        ")
    ; __line = 404
    ; __append(escapeFn( getLocale('season_number_abbr', {'seasonNumber': data.seasonNumber }) ))
    ; __append("\n                    </abbr>\n                </span>\n                <span class=\"meta-white\">\n                    <abbr aria-label=\"Episode ")
    ; __line = 408
    ; __append(escapeFn( data.episodeNumber ))
    ; __append("\" title=\"")
    ; __append(escapeFn( getLocale('episode') ))
    ; __append(" ")
    ; __append(escapeFn( data.episodeNumber ))
    ; __append("\">\n                        ")
    ; __line = 409
    ; __append(escapeFn( getLocale('episode_number_abbr', {'episodeNum': data.episodeNumber }) ))
    ; __append("\n                    </abbr>\n                </span>\n                <span class=\"meta-white meta-white-thin\">")
    ; __line = 412
    ; __append(escapeFn( data.title ))
    ; __append("</span>\n            </div>\n        ")
    ; __line = 414
    ;  } else if(!data.isMovie && data.label) { 
    ; __append("\n            <div class=\"ch-season-episode-wrapper\">\n                <span class=\"meta-white meta-white-semibold\">")
    ; __line = 416
    ; __append(escapeFn( data.label ))
    ; __append("</span>\n            </div>\n        ")
    ; __line = 418
    ;  } 
    ; __append("\n\n        ")
    ; __line = 420
    ;  if (data.about && data.cType == 'ch'){ 
    ; __append("\n            <div class=\"")
    ; __line = 421
    ; __append(escapeFn( data.cType ))
    ; __append("-description ")
    ; __append(escapeFn( data.lockIconClass ))
    ; __append("\">\n                ")
    ; __line = 422
    ; __append(escapeFn( data.about ))
    ; __append("\n            </div>\n        ")
    ; __line = 424
    ;  } 
    ; __append("\n        \n        ")
    ; __line = 426
    ;  if (data.castNames) { 
    ; __append("\n            <div class=\"highlight-cast-wrapper\">\n    <div class=\"highlight-cast\">\n        ")
    ; __line = 429
    ; __append(escapeFn( getLocale('starring_')))
    ; __append(" ")
    ; __append( data.castNames )
    ; __append("\n    </div>\n</div>\n        ")
    ; __line = 432
    ;  } 
    ; __append("\n        \n        ")
    ; __line = 434
    ;  if (data.cType == 'ch' && data.lockIconClass && data.isUserSubscriber){ 
    ; __append("\n            <div class=\"")
    ; __line = 435
    ; __append(escapeFn( data.cType ))
    ; __append("-bundle-locked\">\n                <div class=\"portrait label bundle-lock\">\n                    <img src=\"/assets/images/svg/content_lock.svg\"/>\n                </div>\n                <div class=\"")
    ; __line = 439
    ; __append(escapeFn( data.cType ))
    ; __append("-lock-text\"><span>")
    ; __append(escapeFn( getLocale('get_pplus_showtime')))
    ; __append("</span></div>\n            </div>\n        ")
    ; __line = 441
    ;  } 
    ; __append("\n    ")
    ; __line = 442
    ;  } 
    ; __append("    \n")
    ; __line = 443
    ;  if (data.cType == 'ch') { 
    ; __append("    \n</div>\n")
    ; __line = 445
    ;  } 
    ; __append("\n        ")
    ; __line = 446
    ;  } else { 
    ; __append("\n            ")
    ; __line = 447
    ;  if (data.cType == 'ch') { 
    ; __append("\n<div class=\"")
    ; __line = 448
    ; __append(escapeFn( data.cType ))
    ; __append("-bottom-components\">\n")
    ; __line = 449
    ;  } 
    ; __append("    \n    <div class=\"")
    ; __line = 450
    ; __append(escapeFn( data.cType ))
    ; __append("-info-wrapper\">\n        <!-- check to only show rating if one of the needed values is present -->\n        ")
    ; __line = 452
    ; 
        let neededValues = { genre: data.genre, premiereDate: data.premiereDate, seasonCounts: data.seasonCounts, movieDuration: data.movieDuration };
        let oneNeededValueMet = Object.values(neededValues).some(v => v)
        
    ; __line = 455
    ; __append("\n        \n        <!-- START prominent related -->\n        ")
    ; __line = 458
    ;  if (data.cType == 'prominent') { 
    ; __append("\n            ")
    ; __line = 459
    ;  if ( ((data.locked || data.bundleLocked) && data.isUserSubscriber) || (data.isLocal && data.lockIcon && !data.isUserSubscriber) ) { 
    ; __append("\n            <div class=\"")
    ; __line = 460
    ; __append(escapeFn( data.lockGradientClass ))
    ; __append("\"></div>\n            <div class=\"label ")
    ; __line = 461
    ; __append(escapeFn( data.lockIconClass ))
    ; __append("\">\n                <img src=\"")
    ; __line = 462
    ; __append(escapeFn( data.lockIcon ))
    ; __append("\"/>\n            </div>\n            ")
    ; __line = 464
    ;  } 
    ; __append("\n        ")
    ; __line = 465
    ;  } 
    ; __append("\n        <!-- END prominent related -->\n        \n        ")
    ; __line = 468
    ;  if (typeof(data.genre) !== "undefined" && data.genre){ 
    ; __append("\n            <span>")
    ; __line = 469
    ; __append(escapeFn( data.genre ))
    ; __append("</span>\n        ")
    ; __line = 470
    ;  } 
    ; __append("\n\n        <!-- START prominent related -->\n        ")
    ; __line = 473
    ;  if (data.cType == 'prominent') { 
    ; __append("\n            ")
    ; __line = 474
    ;  if (data.year){ 
    ; __append("\n            <span>")
    ; __line = 475
    ; __append(escapeFn( data.year ))
    ; __append(" </span>\n            ")
    ; __line = 476
    ;  } 
    ; __append("\n        ")
    ; __line = 477
    ;  } 
    ; __append("\n        <!-- END prominent related -->\n\n        <!-- START ch related -->\n        ")
    ; __line = 481
    ;  if (data.cType == 'ch') { 
    ; __append("\n            ")
    ; __line = 482
    ;  if (data.premiereDate && data.genre != 'SPORTS'){ 
    ; __append("\n                <span>")
    ; __line = 483
    ; __append(escapeFn( data.premiereDate ))
    ; __append(" </span>\n            ")
    ; __line = 484
    ;  } 
    ; __append("\n        ")
    ; __line = 485
    ;  } 
    ; __append("\n        <!-- END ch related -->\n        \n        ")
    ; __line = 488
    ;  if ((data.seasonCounts && data.isSeasonless !== true && data.cType == 'ch') || (data.seasonCounts && data.cType == 'prominent')){ 
    ; __append("\n            <span>")
    ; __line = 489
    ; __append(escapeFn( data.numSeasons > 1 ? interpolateUrl(getLocale('_seasons'), {seasonCount: data.numSeasons}).toUpperCase() : getLocale('1_season').toUpperCase() ))
    ; __append("</span>\n        ")
    ; __line = 490
    ;  } 
    ; __append("\n        \n        ")
    ; __line = 492
    ;  if(data.ratingIcon && CBS.Registry.region.international && oneNeededValueMet && data.cType == 'ch') { 
    ; __append("\n            <span class=\"")
    ; __line = 493
    ; __append(escapeFn( data.cType ))
    ; __append("-rating\">\n                <img src=\"")
    ; __line = 494
    ; __append(escapeFn( data.ratingIcon ))
    ; __append("\" />\n            </span>\n        ")
    ; __line = 496
    ;  }else if ((data.rating && oneNeededValueMet && data.cType == 'ch') || (data.rating && !CBS.Registry.region.international && data.cType == 'prominent')){ 
    ; __append("\n            <span class=\"")
    ; __line = 497
    ; __append(escapeFn( data.cType ))
    ; __append("-rating\">")
    ; __append(escapeFn( data.rating ))
    ; __append("</span>\n        ")
    ; __line = 498
    ;  } 
    ; __append("\n\n        <!-- START prominent related -->\n        ")
    ; __line = 501
    ;  if (data.cType == 'prominent') { 
    ; __append("\n            ")
    ; __line = 502
    ;  if (data.runtime){ 
    ; __append("\n            <span>")
    ; __line = 503
    ; __append(escapeFn( data.runtime ))
    ; __append("</span>\n            ")
    ; __line = 504
    ;  } 
    ; __append("\n        ")
    ; __line = 505
    ;  } 
    ; __append("\n        <!-- END prominent related -->\n\n        <!-- START prominent related -->\n        ")
    ; __line = 509
    ;  if (data.cType == 'prominent') { 
    ; __append("\n            ")
    ; __line = 510
    ;  if(data.ratingIcon && CBS.Registry.region.international && data.isMovie) { 
    ; __append("\n            <span class=\"prominent-rating\">\n                        <img src=\"")
    ; __line = 512
    ; __append(escapeFn( data.ratingIcon ))
    ; __append("\" />\n                    </span>\n            ")
    ; __line = 514
    ;  } 
    ; __append("\n        ")
    ; __line = 515
    ;  } 
    ; __append("\n        <!-- END prominent related -->\n\n        <!-- START ch related -->\n        ")
    ; __line = 519
    ;  if (data.cType == 'ch') { 
    ; __append("\n            ")
    ; __line = 520
    ;  if (data.isMovie && data.movieDuration && data.category != 'SPORTS'){ 
    ; __append("\n            <span>")
    ; __line = 521
    ; __append(escapeFn( data.movieDuration ))
    ; __append("</span>\n            ")
    ; __line = 522
    ;  } 
    ; __append("\n        ")
    ; __line = 523
    ;  } 
    ; __append("\n        <!-- END ch related -->\n    </div>\n\n    <!-- START prominent related -->\n    ")
    ; __line = 528
    ;  if (data.cType == 'prominent') { 
    ; __append("\n        ")
    ; __line = 529
    ;  if (data.tuneInTime) { 
    ; __append("\n        <div class=\"prominent-tune-in-time-container\">\n            <p class=\"tuneInTime\"> ")
    ; __line = 531
    ; __append(escapeFn( data.tuneInTime ))
    ; __append(" </p>\n        </div>\n        ")
    ; __line = 533
    ;  } 
    ; __append("\n    ")
    ; __line = 534
    ;  } 
    ; __append("\n    <!-- END prominent related -->\n    \n    ")
    ; __line = 537
    ;  if (data.about && data.cType == 'ch'){ 
    ; __append("\n        <div class=\"")
    ; __line = 538
    ; __append(escapeFn( data.cType ))
    ; __append("-description ")
    ; __append(escapeFn( data.lockIconClass ))
    ; __append("\">\n            ")
    ; __line = 539
    ; __append(escapeFn( data.about ))
    ; __append("\n        </div>\n    ")
    ; __line = 541
    ;  } else if (data.about && data.cType == 'prominent') { 
    ; __append("\n        <div class=\"")
    ; __line = 542
    ; __append(escapeFn( data.cType ))
    ; __append("-description\">\n            <p>")
    ; __line = 543
    ; __append(escapeFn( data.about ))
    ; __append("</p>\n        </div>\n    ")
    ; __line = 545
    ;  } 
    ; __append("\n    \n    ")
    ; __line = 547
    ;  if (data.castNames) { 
    ; __append("\n        <div class=\"highlight-cast-wrapper\">\n    <div class=\"highlight-cast\">\n        ")
    ; __line = 550
    ; __append(escapeFn( getLocale('starring_')))
    ; __append(" ")
    ; __append( data.castNames )
    ; __append("\n    </div>\n</div>\n    ")
    ; __line = 553
    ;  } 
    ; __append("\n    \n    ")
    ; __line = 555
    ;  if (data.cType == 'ch' && data.lockIconClass && data.isUserSubscriber){ 
    ; __append("\n        <div class=\"")
    ; __line = 556
    ; __append(escapeFn( data.cType ))
    ; __append("-bundle-locked\">\n            <div class=\"portrait label bundle-lock\">\n                <img src=\"/assets/images/svg/content_lock.svg\"/>\n            </div>\n            <div class=\"")
    ; __line = 560
    ; __append(escapeFn( data.cType ))
    ; __append("-lock-text\"><span>")
    ; __append(escapeFn( getLocale('get_pplus_showtime')))
    ; __append("</span></div>\n        </div>\n    ")
    ; __line = 562
    ;  } 
    ; __append("\n")
    ; __line = 563
    ;  if (data.cType == 'ch') { 
    ; __append("    \n</div>\n")
    ; __line = 565
    ;  } 
    ; __append("\n        ")
    ; __line = 566
    ;  } 
    ; __append("\n        ")
    ; __line = 567
    ; 
data.watchlist_active_class = data.contentMyListActive ? 'in_watchlist' : ''
data.notify_active_class = data.contentNotificationActive ? 'notify_on' : ''
data.play_icon_class = data.button.play ? 'playIcon' : ''

data.profileType = CBS.Registry.user.profile_type ? CBS.Registry.user.profile_type : '';
let isSearch = CBS.Registry.pageType === "Search"; 

    ; __line = 574
    ; __append("\n\n<div class=\"highlight-cta-wrapper\">\n    <div class=\"button-container ")
    ; __line = 577
    ; __append(escapeFn( data.carouselType === 'keep-watching' ? 'keep-watching' : '' ))
    ; __append("\">\n        <button class=\"button ")
    ; __line = 578
    ; __append(escapeFn(data.play_icon_class))
    ; __append(" highlight-play-button ")
    ; __append(escapeFn( (navigator.userAgent.indexOf('Win') != -1 && data.play_icon_class !== '') ? 'buttonWindows' : '' ))
    ; __append("\"\n                aria-label=\"")
    ; __line = 579
    ; __append(escapeFn(data.button.label))
    ; __append("\"\n                button-url=\"")
    ; __line = 580
    ; __append(escapeFn(data.button.url))
    ; __append("\">\n            <div class=\"button__text\">\n                <span>")
    ; __line = 582
    ; __append(escapeFn(data.button.label))
    ; __append("</span>\n            </div>\n        </button>\n        ")
    ; __line = 585
    ;  if(data.allowMyListControls && !data.scheduleBadge ) { 
    ; __append("\n           \n            <div class=\"button-with-tooltip highlight-watch-list ")
    ; __line = 587
    ; __append(escapeFn(data.watchlist_active_class))
    ; __append(" ")
    ; __append(escapeFn(data.contentMyListActive ? 'active' : ''))
    ; __append("\">\n                <button class=\"highlight-watchlist-cta\"\n                    id=\"watchlist-cta-")
    ; __line = 589
    ; __append(escapeFn(data.id || data.contentId))
    ; __append("\" \n                    aria-label=\"My List Toggle\"\n                    href-add=\"")
    ; __line = 591
    ; __append(escapeFn(data.contentMyListAddActionUrl))
    ; __append("\"\n                    href-remove=\"")
    ; __line = 592
    ; __append(escapeFn(data.contentMyListRemoveActionUrl))
    ; __append("\">\n                    <span class=\"watchlist_copy\">&nbsp;</span>\n                </button>\n                <div class=\"")
    ; __line = 595
    ; __append(escapeFn( (navigator.userAgent.indexOf('Win') != -1) ? 'ch-tooltip-windows' : '' ))
    ; __append(" highlight-tooltip\">\n                    <span class=\"tooltip-text tooltip-add-text\">")
    ; __line = 596
    ; __append(escapeFn( getLocale('add_to_my_list') ))
    ; __append("</span>\n                    <span class=\"tooltip-text tooltip-remove-text\">")
    ; __line = 597
    ; __append(escapeFn( getLocale('remove_from_my_list') ))
    ; __append("</span>\n                </div>\n            </div>\n            \n            ")
    ; __line = 601
    ;  if (!CBS.Registry.region.international && data.profileType === 'ADULT') { 
    ; __append("\n                <div class=\"button-with-tooltip highlight-notify ")
    ; __line = 602
    ; __append(escapeFn(data.notify_active_class))
    ; __append(" ")
    ; __append(escapeFn(data.contentNotificationActive ? 'active' : ''))
    ; __append("\">\n                    <button class=\"highlight-notify-bell-cta\"\n                        id=\"notify-cta-")
    ; __line = 604
    ; __append(escapeFn(data.id || data.contentId))
    ; __append("\"\n                        aria-label=\"Notifications Toggle\"\n                        href-add=\"")
    ; __line = 606
    ; __append(escapeFn(data.contentNotificationAddActionUrl))
    ; __append("\"\n                        href-remove=\"")
    ; __line = 607
    ; __append(escapeFn(data.contentNotificationRemoveActionUrl))
    ; __append("\"\">\n                        <span class=\"notify_copy\">&nbsp;</span>\n                    </button>\n                    <div class=\"")
    ; __line = 610
    ; __append(escapeFn( (navigator.userAgent.indexOf('Win') != -1) ? 'ch-tooltip-windows' : '' ))
    ; __append(" highlight-tooltip highlight-tooltip-notify\">\n                        <span class=\"tooltip-text tooltip-add-text\">")
    ; __line = 611
    ; __append(escapeFn( getLocale('notify_me') ))
    ; __append("</span>\n                        <span class=\"tooltip-text tooltip-remove-text\">")
    ; __line = 612
    ; __append(escapeFn( getLocale('turn_off_notifications') ))
    ; __append("</span>\n                    </div>\n                </div>\n            ")
    ; __line = 615
    ;  } 
    ; __append("\n        ")
    ; __line = 616
    ;  } 
    ; __append("\n    </div>\n</div>\n    </div>\n</a>\n")
    ; __line = 621
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL="node_modules/.pnpm/git@github.com+cbsi-cbscom+web-package-coreui@301dafbfd58a29a8a3f92aaf155c0754515287fb_fetch-_62wmhmako2s37xw6vgzewjn2le/node_modules/cbs-core-ui/src/js/templates/carousels/highlightCarousel/expandingContainer.tpl"

}